import { render } from "./BrandCallLog.vue?vue&type=template&id=ea606242"
import script from "./BrandCallLog.vue?vue&type=script&lang=js"
export * from "./BrandCallLog.vue?vue&type=script&lang=js"

import "./BrandCallLog.vue?vue&type=style&index=0&id=ea606242&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__